export const keys = {
  general: {
    restUrl: process.env.NEXT_PUBLIC_REST_URL,
    enableBot: process.env.NEXT_PUBLIC_ENABLE_BOT,
    websiteUrl: process.env.NEXT_PUBLIC_WEBSITE_URL,
    graphqlUrl: process.env.NEXT_PUBLIC_GRAPHQL_URL,
    reviewAPIUrl: process.env.NEXT_PUBLIC_REVIEW_API,
    backendGraphqlUrl: process.env.NEXT_PUBLIC_BACKEND_GRAPHQL_URL,
    addExtension: process.env.NEXT_PUBLIC_APP_PAGE_EXTENSION === "1",
  },
};
